import { OrderType, useSearchExamCoursesQuery } from '@exam-management/graphql';
import { FormSearchSelection } from '@shared/components';

interface ExamCourseDropDownSelectionFormProps {
  name?: string;
}
export default function ExamCourseDropDownSelectionForm(
  props: Readonly<ExamCourseDropDownSelectionFormProps>,
) {
  const { name } = props;
  const { data, loading: isLoading } = useSearchExamCoursesQuery({
    variables: {
      searchExamCoursesInput: {
        order: {
          field: 'examId',
          type: OrderType.Asc,
        },
        paging: {
          currentPage: 0,
          pageSize: 200,
        },
      },
    },
  });

  const examinationCourseOptions = (data?.excSearchExamCourses.examCourses ?? []).map((course) => ({
    label: course.name,
    value: course.id,
  }));

  return (
    <FormSearchSelection
      label='เลือกหลักสูตรทดสอบ'
      name={name ?? 'examCourseSelection.examCourseId'}
      options={examinationCourseOptions}
      loading={isLoading}
      placeholder='เลือกหลักสูตรทดสอบ'
      noOptionsText='ไม่พบข้อมูล'
    />
  );
}
